
export enum AccountFleetType {
    Unknown,
    HGV,
    Car,
    Van,
    Mixed
}
